import { AxiosError } from 'axios'
import { ERROR_MESSAGES } from '@/config/constants'
import { ApiError } from '@/types'

export const handleApiError = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const apiError = error.response?.data as ApiError

    // Extract error message from response.data.message
    if (apiError?.message) {
      // Map backend error codes to user-friendly messages
      switch (apiError.message) {
        case 'MISSMATCH_CREDENTIALS':
          return ERROR_MESSAGES.MISSMATCH_CREDENTIALS
        case 'CODE_MISSMATCH_EXPIRED':
          return ERROR_MESSAGES.CODE_MISSMATCH_EXPIRED
        case 'USER_NOT_FOUND':
          return ERROR_MESSAGES.USER_NOT_FOUND
        case 'USER_EMAIL_EXISTS':
        case 'USER_EMAI_EXISTS': // Handle typo variant
          return ERROR_MESSAGES.USER_EMAIL_EXISTS
        case 'FORBIDDEN':
          return ERROR_MESSAGES.FORBIDDEN
        case 'BAD_REQUEST':
          return ERROR_MESSAGES.VALIDATION_ERROR
        case 'Unauthorized':
        case 'UNAUTHORIZED':
          return ERROR_MESSAGES.UNAUTHORIZED
        default:
          // If it's a known error code but not mapped, return the code
          // Otherwise return a generic error message
          return ERROR_MESSAGES.UNKNOWN_ERROR
      }
    }

    // Handle HTTP status codes
    switch (error.response?.status) {
      case 400:
        return ERROR_MESSAGES.VALIDATION_ERROR
      case 401:
        return ERROR_MESSAGES.UNAUTHORIZED
      case 403:
        return ERROR_MESSAGES.FORBIDDEN
      case 404:
        return ERROR_MESSAGES.NOT_FOUND
      case 409:
        // Conflict errors - map the error code to user-friendly message
        if (apiError?.message) {
          switch (apiError.message) {
            case 'USER_EMAIL_EXISTS':
            case 'USER_EMAI_EXISTS': // Handle typo variant
              return ERROR_MESSAGES.USER_EMAIL_EXISTS
            default:
              return ERROR_MESSAGES.VALIDATION_ERROR
          }
        }
        return ERROR_MESSAGES.VALIDATION_ERROR
      case 500:
      case 502:
      case 503:
        return ERROR_MESSAGES.SERVER_ERROR
      default:
        if (!error.response) {
          return ERROR_MESSAGES.NETWORK_ERROR
        }
        return ERROR_MESSAGES.UNKNOWN_ERROR
    }
  }

  if (error instanceof Error) {
    return error.message
  }

  return ERROR_MESSAGES.UNKNOWN_ERROR
}

export const getValidationErrors = (error: unknown): string[] => {
  if (error instanceof AxiosError) {
    const apiError = error.response?.data as ApiError
    if (apiError?.error) {
      if (Array.isArray(apiError.error)) {
        return apiError.error
      }
      return [apiError.error]
    }
  }
  return []
}
